// extracted by mini-css-extract-plugin
export var dark = "styles-module--dark--5f088";
export var panelError = "styles-module--panelError--d3466";
export var panelWithTabs = "styles-module--panelWithTabs--c2cba";
export var tab = "styles-module--tab--70c0b";
export var title = "styles-module--title--7dc60";
export var transparent = "styles-module--transparent--0b687";
export var wrapper = "styles-module--wrapper--4f3b5";